import React from 'react';
export function PassThrough(props) {
    var children = props.children;
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return React.createElement(React.Fragment, null, children);
}
